module.exports = __webpack_public_path__ + "img/MapStyles_3_Hybrid_1024@0,25x@0,25x.669aebf3.png";